import { render, staticRenderFns } from "./GenerateLinkComponent.vue?vue&type=template&id=07850c28&scoped=true"
import script from "./GenerateLinkComponent.vue?vue&type=script&lang=ts"
export * from "./GenerateLinkComponent.vue?vue&type=script&lang=ts"
import style0 from "./GenerateLinkComponent.vue?vue&type=style&index=0&id=07850c28&prod&lang=scss"
import style1 from "./GenerateLinkComponent.vue?vue&type=style&index=1&id=07850c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07850c28",
  null
  
)

export default component.exports